import {
  isTripPayment,
  type StandardInitiatePaymentParams,
} from "@/app/payments/types";

export const constructOrderApiParams = (
  params: StandardInitiatePaymentParams,
) => {
  if (isTripPayment(params)) {
    const { serviceType, ...rest } = params;

    return {
      apiUrl: "/orders/package",
      apiParams: rest,
    };
  } else {
    const { availabilityTokens, promoCode } = params;

    return {
      apiUrl: "/orders",
      apiParams: {
        availabilityTokens,
        promoCode,
      },
    };
  }
};
